import ProjectHeaderMainDetails from './ProjectHeaderMainDetails';

export default ProjectHeaderMainDetails;
